<template>
    <div class="search-by-tag component">
      <div class="overlay" :class="{'full-size': fullSize}">
        <div class="content">
          <input
            ref="search"
            v-model="query"
            v-debounce="1000"
            @keyup.esc="onEsc"
            @blur="onBlur"
            @click="fullSize = true"
            @debounce-change="searchTagHandler"
            type="text"
            :class="{'full-size': fullSize}"
            placeholder="search">

          <div class="result" v-if="fullSize">
            <UiDataBox :loading="loading">
              <div class="tag" v-for="tag in tags" :key="tag.id" v-if="tags.length">
                <router-link :to="{ name: 'tag', params: { name: tag.name }}">{{ tag.name }}</router-link>
              </div>
              <div class="tag" v-if="!tags.length && !success">
                nope, nothing there
              </div>
            </UiDataBox>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import * as tagsService from '../services/tags.service'
  import debounce from '../directives/debounce'

  export default {
    name: 'SearchByTag',

    directives: {
      debounce
    },

    data () {
      return {
        loading: false,
        error: false,
        success: true,
        fullSize: false,
        query: '',
        tags: []
      }
    },

    methods: {
      onBlur () {
        setTimeout(() => {
          this.fullSize = false
          this.query = ''
          this.tags = []
        }, 200)
      },
      onEsc () {
        this.$refs.search.blur()
      },
      searchTagHandler () {
        this.tags = []
        if (!this.query || this.query.length < 2) return

        this.loading = true
        tagsService.find({q: this.query})
          .then(response => {
            this.tags = response.data.content
            this.success = response.success
          }).catch(error => {
            this.error = error.message
            this.success = error.success
          }).finally(response => (this.loading = false))
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-by-tag.component {
    .overlay.full-size {
      position: absolute;
      top: 0;
      left: 0;
      padding: 200px 0;
      width: 100%;
      height: 100%;
      background-color: $color-black-transparent;
      z-index: 10;

      .content {
        text-align: center;
        font-size: 20px;
        margin: 0 auto;
        max-width: $size-max-width;
        .result {
          max-height: 600px;
          overflow: auto;
          position: relative;
          background-color: $color-gray-transparent;
          .tag {
            padding: 20px 0;
            &:hover {
              background-color: $color-body;
            }

            a {
              display: block;
            }
          }
        }
      }
    }

    input {
      display: block;
      position: relative;
      width: 200px;
      text-align: center;
      padding: 0 20px;
      border: 2px solid $color-white;
      transition: all .4s;
      &.full-size {
        width: 100%;
        height: 100px;
        font-size: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchByTag.vue